module.exports = "https://web-assets-production.autolist.com/_next/static/images/minivan-d0e57b1cad6e1b5cd452c56998549d73.png";